import React, { useRef } from 'react';
import { Dots } from '@yme/atoms/dots';
import { useElementCenter, useMouseDrag, useWindowSize } from '@yme/hooks/index';
import { ThumbnailList } from './ThumbnailList';
import { DotsContainerStyled, ThumbnailsContainerStyled, ThumbnailsTrackStyled } from './styled';
import { useThumbnailsConfig } from './useThumbnailsConfig';
export function GalleryThumbnails({ items, thumbnailsAmount, thumbnailsIndent, onShowItem, isRightToLeft, currentIndex, hasPadding, isInLightbox, thumbnailAspectRatio, }) {
    const { thumbnailConfig } = useThumbnailsConfig(thumbnailsAmount, thumbnailsIndent);
    const ref = useRef(null);
    const containerRef = useRef(null);
    const { mouseEventHandlers } = useMouseDrag(containerRef);
    const { isInfiniteDesktopView } = useWindowSize();
    useElementCenter(ref, containerRef);
    if (!isInfiniteDesktopView) {
        return (React.createElement(ThumbnailsContainerStyled, { hasPadding: hasPadding, isInLightbox: isInLightbox, withDots: true }, items.length > 1 ? (React.createElement(DotsContainerStyled, { isInLightbox: isInLightbox },
            React.createElement(Dots, { isDotsFixed: true, counts: items.length, activeItem: currentIndex, isRightToLeft: isRightToLeft }))) : null));
    }
    return (React.createElement(ThumbnailsContainerStyled, { hasPadding: hasPadding },
        React.createElement(ThumbnailsTrackStyled, { ref: containerRef, ...mouseEventHandlers },
            React.createElement(ThumbnailList, { thumbnailAspectRatio: thumbnailAspectRatio, amount: thumbnailConfig.amount, currentIndex: currentIndex, indent: thumbnailConfig.indent, isRightToLeft: isRightToLeft, items: items, onShowItem: onShowItem, thumbnailRef: ref, isInLightbox: isInLightbox }))));
}
